import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import React from "react";
import styled from "styled-components";

import { ActionModal } from "./ActionModal/ActionModal";
import { ActionTypeContextProvider } from "./hooks/ActionTypeContext";
import { useActionTypes } from "./hooks/useActionTypes";
import { QuickActionButton } from "./QuickActionButton";
import { QuickActionsHeader } from "./QuickActionsHeader";

export enum QuickActionOrigin {
  HelpCenter = "help_center",
  SelfServe = "self_serve",
}

export interface IQuickActionsProps {
  origin: QuickActionOrigin;
  hideHeader?: boolean;
}

const QuickActionsBase: React.FC<IQuickActionsProps> = ({
  origin,
  hideHeader,
}) => {
  const { actionTypes, setActionType } = useActionTypes();
  return (
    <QuickActionsWrapper origin={origin}>
      <QuickActionsHeader origin={origin} hideHeader={hideHeader} />
      {actionTypes.map((actionType, index) => (
        <React.Fragment key={index}>
          {index === 0 ? null : <Spacer height="2x" />}
          <QuickActionButton
            actionType={actionType}
            setActionType={setActionType}
            origin={origin}
          />
        </React.Fragment>
      ))}
      <ActionModal />
    </QuickActionsWrapper>
  );
};

export const QuickActions: React.FC<IQuickActionsProps> = (props) => (
  <ActionTypeContextProvider>
    <QuickActionsBase {...props} />
  </ActionTypeContextProvider>
);

const QuickActionsWrapper = styled(Column).attrs({ align: "flex-start" })<{
  origin: QuickActionOrigin;
}>`
  border: ${(props) =>
    props.origin === QuickActionOrigin.HelpCenter
      ? `1px solid ${Core.border.muted}`
      : "none"};
  padding: ${getSpacing("2x", "3x", "3x")};
  width: 100%;
  background-color: ${(props) =>
    props.origin === QuickActionOrigin.HelpCenter
      ? Core.surface.inverse
      : Core.surface.muted};
  height: fit-content;
  min-width: 303px;
`;
